import { useSelector } from "react-redux";
import {
  getBasicDataForChargesOfResources,
  selectState,
} from "../slices/dtBilledResources.slice";
import { useAppDispatch } from "hooks/hooks";
import { useCallback, useEffect, useState } from "react";
import { IResourceCharge } from "../domain/IResourceCharge";
import Loader from "components/Loader/Loader";
import DateSelector from "Dashboard/components/DateSelector";
import { FormatDateIso, FormatDateShort } from "utils/dateUtils";
import { FormatNumberOrNull } from "utils/numberUtils";
import { unitNameLabel } from "Dashboard/scenes/Resources/helpers/resourceUtil";
import InfoTooltip from "components/Popup/InfoTooltip";

export const ResourceChargesPreview = () => {
  const { charges, loading } = useSelector(selectState);
  const [dateFrom, setDateFrom] = useState<Date | null>(null);
  const [dateTo, setDateTo] = useState<Date | null>(null);
  const dispatch = useAppDispatch();

  const selectDate = useCallback((data: { dateFrom: Date; dateTo: Date }) => {
    setDateFrom(data.dateFrom);
    setDateTo(data.dateTo);
  }, []);

  useEffect(() => {
    if (dateFrom && dateTo) {
      dispatch(
        getBasicDataForChargesOfResources({
          dateFrom: FormatDateIso(dateFrom),
          dateTo: FormatDateIso(dateTo),
        }));
    }
  }, [dispatch, dateFrom, dateTo]);

  return (
    <div className="daily-table-resource-charges loading-container">
      {loading && <Loader />}
      <div className="previewHeader">
        <div className="bolded">ZADUŽENJE RESURSA</div>
        <div>
          <DateSelector showYear={false} selectDate={selectDate} />
        </div>
      </div>
      <div className="extendedPreviewBody">
        {charges.map((charge: IResourceCharge) => (
          <div className="singleChargedResource">
            <InfoTooltip
              tooltip={charge.resourceName}
              classesProp="daily-table-charges-resource text-overflow"
              element="span"
            >
              {charge.resourceName}
            </InfoTooltip>
            <span className="daily-table-charges-employee">{charge.employeeName}</span>
            <InfoTooltip
              tooltip={charge.projectName}
              classesProp="daily-table-charges-project text-overflow"
              element="span"
            >
              {charge.projectName}
            </InfoTooltip>
            {charge.usageAmount && (
              <>
                <span className="daily-table-charges-usage">{FormatNumberOrNull(charge.usageAmount)}</span>
                <span className="daily-table-charges-unit">{unitNameLabel(charge.usageUnit)}</span>
              </>
            )}
            <span className="daily-table-charges-date">{FormatDateShort(charge.date)}</span>
          </div>
        ))}
        {charges.length < 4 && <div className="singleChargedResource"></div>}
        {charges.length < 3 && <div className="singleChargedResource"></div>}
        {charges.length < 2 && <div className="singleChargedResource"></div>}
        {charges.length < 1 && <div className="singleChargedResource"></div>}
      </div>
    </div>
  );
};
